<template>
  <div class="row">
    <div class="col-lg-12" v-if="result">
      <table class="table table-hover table-striped">
        <thead>
        <tr>
          <th>Keyword</th>
          <th>Rank</th>
          <th>Volume</th>
          <th>CPC</th>
          <th>Competition</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="kw in result.data.targetKeywords" :key="'kw-' + kw.keyword" :class="kw.keyword === result.payload.keyword ? 'bold' : ''">
          <td>{{ kw.keyword }}</td>
          <td>{{ kw.rank }}</td>
          <td>{{ kw.volume }}</td>
          <td>{{ kw.cpc }}</td>
          <td>{{ kw.competition }}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
export default {
  props: ['result']
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Single/Tabs/PageEntity/TargetKeywords.vue